// extracted by mini-css-extract-plugin
export default {"solutionAtlassianProductDiversion":"SolutionAtlassianProductDiversion__solutionAtlassianProductDiversion--Ye","introduction":"SolutionAtlassianProductDiversion__introduction--xL"};